<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Search query"
              v-model="formData.search"
            />
          </div>
          <div class="form-search__double">
            <label class="form__label">Search By</label>
            <select class="form__input" v-model="formData.search_by">
              <option value="">(Please Choose)</option>
              <option value="username">Username / ID</option>
              <option value="bank">Bank</option>
            </select>
          </div>
        </div>

        <div class="form-search__action">
          <div class="w-3/12 flex">
            <BaseButton type="submit" class="mr-2" buttonClass="secondary"
              >Search</BaseButton
            >
          </div>
        </div>
      </form>
      <vue-good-table
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :is-loading.sync="tableData.isLoading"
        :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: perPageDropdown,
          rowsPerPageLabel: 'Results per page',
        }"
        :sort-options="{
          multipleColumns: false,
        }"
        styleClass="vgt-table striped bordered"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
        @on-sort-change="onSortChange"
        @on-search="onSearchChange"
        @on-column-filter="onColumnFilter"
      >
        <template slot="table-row" slot-scope="props">
          <template v-if="props.column.field == 'member_bank_accounts'">
            <span
              class="block"
              v-for="bank in props.row.member_bank_accounts"
              :key="bank.id"
            >
            {{ bank.holder }} - {{ bank.number }}
              <!-- <router-link
                :to="{
                  name: 'MemberBankEdit',
                  params: { memberId: props.row.uuid, id: bank.uuid },
                }"
                class="link"
                v-tooltip="'Edit ' + bank.name"
                >{{ bank.name }}
              </router-link> -->
            </span>
          </template>
          <template v-else-if="props.column.field == 'member_accounts'">
            <span
              class="block"
              v-for="account in props.row.member_accounts"
              :key="account.id"
            >
              {{ account.panel_id }}
              <!-- <router-link
                :to="{
                  name: 'AccountEdit',
                  params: { memberId: props.row.uuid, id: account.uuid },
                }"
                class="link"
                v-tooltip="'Edit ' + account.name"
              >
                {{ account.name }}
              </router-link> -->
              <span class="block mt-1 mb-2"
                ><font-awesome-icon :icon="['fas', 'coins']" class="mr-1" />
                <template v-if="account.balance">{{ account.balance }}</template
                ><template v-else>0.00</template></span
              >
            </span>
          </template>
          <span v-else-if="props.column.field == 'uuid'">Migrate Here</span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";

export default {
  mixins: [showListMixin],
  data() {
    return {
      formData: {
        search_by: "",
      },
      tableData: {
        columns: [
          {
            label: "Name",
            field: "member.name",
            sortable: false,
          },
          {
            label: "Bank Accounts",
            field: "member_bank_accounts",
            sortable: false,
          },
          {
            label: "Account IDs",
            field: "member_accounts",
            sortable: false,
          },
          {
            label: "",
            field: "uuid",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
            sortable: false,
          },
        ],
        order_field: "name",
        order_dir: "asc",
      },
    };
  },
  methods: {
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.loadTableData();
      }
    },
    loadTableData() {
      if (this.formData.search) {
        this.debounce(() => {
          this.tableData.isLoading = true;
          this.$http
            .get(
              process.env.VUE_APP_API_URL +
                `/migrate?&search=${this.formData.search}&search_by=${this.formData.search_by}`
            )
            .then((res) => {
              this.tableData.rows = res.data.data;
              this.tableData.totalRows = res.data.total;
            });
        }, 500);
      }
    },
    migrate(memberId) {
      this.$store.commit("toggleLoading");

      this.$http({
        method: "patch",
        url: process.env.VUE_APP_API_URL + this.$route.path + "/" + memberId,
      })
        .then((res) => {
          this.$swal({
            title: res.data.title,
            text: res.data.message,
            icon: res.data.icon,
          });
        })
        .catch(() => {
          this.$swal({
            title: "Whoops!",
            text: "An error has occurred. Please contact the system admin.",
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.commit("toggleLoading");
        });
    },
  },
};
</script>
